import config from '@framework/config';
import TenantConfig from '@framework/tenant/TenantConfig';
import { checkSessionWithZeroTolerance } from '../helpers';
import Container from '@framework/di/Container';
import { FetchInterceptorResponse } from 'fetch-intercept';
import tenants from '@framework/tenant/tenants';

const checkSession = (container: Container) => async (
  response: FetchInterceptorResponse,
): Promise<FetchInterceptorResponse> => {
  const code = response.status;

  // This are our finsight projects, we dont want 403 of any 3d party to be treated.
  const securedHostnames = Object.keys(tenants).reduce(
    (acc, key) => [...acc, TenantConfig.fromObject((tenants as Record<string, any>)[key]).hostname],
    [
      `${ config.apiDomain }`,
    ],
  );

  if (
    // This are our finsight projects, we dont want 403 of any 3d party to be treated.
    securedHostnames.some((hostname) => response.url.includes(hostname)) &&
    // And also rest requests with currentUser in signature are excluded
    !response.url.includes('currentUser') &&
    // This is our trigger, that something went wrong
    (code === 401 || code === 403)
  ) {
    await checkSessionWithZeroTolerance(container);
  }

  return response;
};

export { checkSession };
